import React, { useEffect, useState, lazy, Suspense } from "react";
import "./App.css";
import "./styles/global-apple-fonts.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { PageTransition } from "./components/animations/PageTransition";
import { SkeletonLoader } from "./components/SkeletonLoader";
import { PreloadResources } from "./components/PreloadResources";

// Lazy load pages for better performance
const Home = lazy(() => import("./pages/Home").then(module => ({ default: module.Home })));
const Product = lazy(() => import("./pages/Product").then(module => ({ default: module.Product })));
const About = lazy(() => import("./pages/About").then(module => ({ default: module.About })));
const FAQ = lazy(() => import("./pages/FAQ").then(module => ({ default: module.FAQ })));
const Contact = lazy(() => import("./pages/Contact").then(module => ({ default: module.Contact })));
const Demo = lazy(() => import("./pages/Demo").then(module => ({ default: module.Demo })));
const Privacy = lazy(() => import("./pages/Privacy").then(module => ({ default: module.Privacy })));
const Terms = lazy(() => import("./pages/Terms").then(module => ({ default: module.Terms })));
const Careers = lazy(() => import("./pages/Careers").then(module => ({ default: module.Careers })));
const Integrations = lazy(() => import("./pages/Integrations").then(module => ({ default: module.Integrations })));

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
}

// Scroll progress indicator
function ScrollProgress() {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div 
      className="scroll-progress" 
      style={{ transform: `scaleX(${scrollProgress / 100})` }}
    />
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PreloadResources />
        <ScrollProgress />
        <ScrollToTop />
        <Header />
        <Suspense fallback={<SkeletonLoader />}>
          <PageTransition>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/product" element={<Product />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/integrations" element={<Integrations />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/demo" element={<Demo />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
            </Routes>
          </PageTransition>
        </Suspense>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
